// copy from src/components/discovery/store-locator/apis/google-geocoder-api.ts

import {
  Geocodes,
  GeocodesModel,
  ReverseGeocodeModel,
  type ReverseGeocodes
} from 'components/ordering/delivery-match/api/google-geocoder.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import type { GeolocationType } from 'components/ordering/delivery-match/geolocation-type.js'

export const GOOGLE_GEOCODER_API = Symbol('GOOGLE_GEOCODER_API')



export class GoogleGeocodeRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = {
    Accept: 'application/json',
    RequestMode: 'no-cors'
  }
  controller: AbortController = new AbortController()

  constructor(address: string, proxy: string) {
    this.endpointUrl = new URL(proxy, window.location.href)

    const geocodeUrl = new URL('https://maps.googleapis.com/maps/api/geocode/json')
    geocodeUrl.searchParams.set('address', address)

    this.endpointUrl.searchParams.set('url', geocodeUrl.href)
  }
}
export class GoogleReverseGeocodeRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = {
    Accept: 'application/json',
    RequestMode: 'no-cors'
  }
  controller: AbortController = new AbortController()

  constructor(location: GeolocationType, proxy: string) {
    this.endpointUrl = new URL(proxy, window.location.href)

    const geocodeUrl = new URL('https://maps.googleapis.com/maps/api/geocode/json')
    geocodeUrl.searchParams.set('latlng', `${location.lat},${location.lon}`)

    this.endpointUrl.searchParams.set('url', geocodeUrl.href)
  }
}


@registerDependency(FAKE, GOOGLE_GEOCODER_API)
export class FakeGoogleGeocoderApi {

  zips: ReverseGeocodes = new ReverseGeocodeModel()
  coordinates: Geocodes = new GeocodesModel()
  requests: GoogleGeocodeRequest[] = []

  geocode(request: GoogleGeocodeRequest | GoogleReverseGeocodeRequest) {
    this.requests.push(request)
    if(request instanceof GoogleReverseGeocodeRequest) {
      return Promise.resolve(this.zips)
    }
    return Promise.resolve(this.coordinates)
  }
}

@registerDependency(REAL, GOOGLE_GEOCODER_API)
export class GoogleGeocodeApi {

  async geocode(request: GoogleGeocodeRequest): Promise<unknown> {
    return await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers
    }).then(r => r.json())
  }
}
